import { call, put, takeLatest } from 'redux-saga/effects';
import { GET_TERRITORIES_LIST } from './constants';
import { setTerritoriesList } from './actions';
import { loadingRequest, loadingSuccess } from '@stores/global/actions';
import { hasValue } from '@helpers/utils/utils';
import { getERecognitionTerritoriesService } from '@services/eRecognition';

export function* getERecognitionTerritoriesList({ payload }) {
  try {
    yield put(loadingRequest());
    const response = yield call(getERecognitionTerritoriesService, {
      saleChannel: payload.saleChannel,
      type: payload.type,
    });
    const allTerritories = {
      rangeDetailCode: 'ALL',
      rangeDetailLabel: 'Tất cả (All)',
    };
    if (hasValue(response)) {
      let territoriesList = [allTerritories];
      if (response.length > 0) {
        response.forEach((element) => {
          territoriesList.push({
            rangeDetailCode: element.teamCode,
            rangeDetailLabel: element.teamName,
          });
        });
      } else {
        territoriesList = [allTerritories];
      }
      yield put(setTerritoriesList(territoriesList));
    }
    yield put(loadingSuccess());
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
  }
}

export default function* eRecognitionSaga() {
  yield takeLatest(GET_TERRITORIES_LIST, getERecognitionTerritoriesList);
}
